import React from "react";

export default function About({ profile, visitor }) {
  return (
    <div className="profile_card">
      <div className="profile_card_header">
        About
      </div>
      
      <div className="about_content">
        {profile.details?.bio && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="info_icon"></i>
              Bio
            </div>
            <div className="about_section_content">
              {profile.details.bio}
            </div>
          </div>
        )}

        {profile.details?.job && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="work_icon"></i>
              Work
            </div>
            <div className="about_section_content">
              {profile.details.job}
            </div>
          </div>
        )}

        {profile.details?.workplace && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="work_icon"></i>
              Workplace
            </div>
            <div className="about_section_content">
              {profile.details.workplace}
            </div>
          </div>
        )}

        {profile.details?.highSchool && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="studies_icon"></i>
              High School
            </div>
            <div className="about_section_content">
              {profile.details.highSchool}
            </div>
          </div>
        )}

        {profile.details?.college && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="studies_icon"></i>
              College
            </div>
            <div className="about_section_content">
              {profile.details.college}
            </div>
          </div>
        )}

        {profile.details?.currentCity && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="home_icon"></i>
              Lives in
            </div>
            <div className="about_section_content">
              {profile.details.currentCity}
            </div>
          </div>
        )}

        {profile.details?.hometown && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="home_icon"></i>
              From
            </div>
            <div className="about_section_content">
              {profile.details.hometown}
            </div>
          </div>
        )}

        {profile.details?.relationship && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="relationship_icon"></i>
              Relationship
            </div>
            <div className="about_section_content">
              {profile.details.relationship}
            </div>
          </div>
        )}

        {profile.details?.instagram && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="instagram_icon"></i>
              Instagram
            </div>
            <div className="about_section_content">
              <a href={`https://instagram.com/${profile.details.instagram}`} target="_blank" rel="noopener noreferrer">
                @{profile.details.instagram}
              </a>
            </div>
          </div>
        )}

        {profile.details?.hobbies && profile.details.hobbies.length > 0 && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="hobbies_icon"></i>
              Hobbies
            </div>
            <div className="about_section_content">
              <div className="hobbies_display_list">
                {profile.details.hobbies.map((hobby, index) => (
                  <span key={index} className="hobby_display_tag">
                    {hobby}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}

        {profile.details?.featured && profile.details.featured.length > 0 && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="featured_icon"></i>
              Featured
            </div>
            <div className="about_section_content">
              <div className="featured_display_list">
                {profile.details.featured.map((item, index) => (
                  <div key={index} className="featured_display_item">
                    <span className="featured_display_icon">
                      {item.type === 'work' ? '💼' : 
                       item.type === 'education' ? '🎓' : 
                       item.type === 'achievement' ? '🏆' : 
                       item.type === 'project' ? '🚀' : '⭐'}
                    </span>
                    <div className="featured_display_content">
                      <div className="featured_display_title">{item.title}</div>
                      {item.description && (
                        <div className="featured_display_description">{item.description}</div>
                      )}
                      {item.link && (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="featured_link">
                          View Link
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="about_section">
          <div className="about_section_header">
            <i className="date_icon"></i>
            Joined
          </div>
          <div className="about_section_content">
            {new Date(profile.createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long'
            })}
          </div>
        </div>
      </div>
    </div>
  );
} 